var render = function render(_c,_vm){return _c('g',[_c('title',[_vm._v(_vm._s(_vm._f("t")('Pages.ProductDetail.ProductVariantPicker.DimensionImageAltText')))]),_c('path',{staticClass:"cls-1",attrs:{"d":"M17.34,1h0L1,17.34H1L6.66,23,23,6.66ZM3.1,17.34l1.17-1.18,1.51,1.51,1-1.05-1.51-1.5L7.42,13l2.21,2.19,1-1L8.47,12l2.1-2.1,1.51,1.51,1-1-1.5-1.51,2.1-2.1,2.2,2.21,1-1-2.2-2.21L17.34,3.1,20.9,6.66,6.66,20.9Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }